// hooks/useAvailableDates.js - PRODUCTION VERSION (clean, no console logs)
import { useState, useEffect } from 'react';
import { getDateValue, getTodayDate } from '../utils/dateUtils';

export const useAvailableDates = (city, refreshKey) => {
    const [availableDates, setAvailableDates] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAvailableDates = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const dates = [];
                // Check each of the 7 days
                for (let i = 0; i < 7; i++) {
                    const dateValue = getDateValue(i);

                    try {
                        const queryString = `?date=${dateValue}&city=${city}`;
                        const response = await fetch(`https://eventspire.nl/api/movies_with_cinemas/${queryString}`);

                        if (!response.ok) {
                            continue;
                        }

                        // Get the raw text first
                        const responseText = await response.text();

                        // Check if response is empty or just whitespace
                        if (!responseText || responseText.trim() === '') {
                            continue;
                        }

                        // Try to parse as JSON
                        let data;
                        try {
                            data = JSON.parse(responseText);
                        } catch (parseError) {
                            // If it's not JSON, it's probably an error page or empty response
                            // Don't include this date
                            continue;
                        }

                        // Check if there are any movies for this date
                        if (data && Array.isArray(data) && data.length > 0) {
                            dates.push(dateValue);
                        } else if (data && !Array.isArray(data) && Object.keys(data).length > 0) {
                            dates.push(dateValue);
                        }
                    } catch (dateError) {
                        // Skip dates with errors
                        continue;
                    }
                }

                // If no dates were found, include at least today as fallback
                if (dates.length === 0) {
                    dates.push(getTodayDate());
                }

                setAvailableDates(dates);
            } catch (err) {
                setError(err);
                // Fallback: include just today if there's a general error
                setAvailableDates([getTodayDate()]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAvailableDates();
    }, [city, refreshKey]);

    return { availableDates, isLoading, error };
};
